import {
    CLEAR_FILTER,
    FORWARD_TIME_CHANGE, FORWARD_TIME_TYPE_CHANGE, PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS,
    SET_SELECTED_URL_FILTERS
} from "../../actions/FlightsActions";

export const initialState = {
    type: 'departure',
    start: 0,
    end: 24
};

const ForwardTimeFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case FORWARD_TIME_CHANGE:
            return {
                ...state,
                start: action.payload.start === undefined ? state.start : action.payload.start,
                end: action.payload.end === undefined ? state.end : action.payload.end
            };
        case FORWARD_TIME_TYPE_CHANGE:
            return {
                ...state,
                type: action.payload
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'forwardTime') {
                return {
                    ...state,
                    type: action.payload.type,
                    startSelected: parseInt(action.payload.start, 10),
                    endSelected: parseInt(action.payload.end, 10)
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {...state,
                type: action.filters.forwardTime.type,
                start: action.filters.forwardTime.start,
                end: action.filters.forwardTime.end
            };
        case CLEAR_FILTER:
            if (action.filter === 'forwardTime') {
                return {...state, start: initialState.start, end: initialState.end};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, start: initialState.start, end: initialState.end};
        default:
            return state
    }
};

export default ForwardTimeFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/ForwardTimeFilterReducer.js